import { useQuery, UnusedSkipTokenOptions } from '@tanstack/react-query'
import {
	GetTrueMoneyDepositsParams,
	TrueMoneyDepositsResponse,
} from '@/modules/transaction/types'
import { queryTrueMoneyDepositsOptions } from './options'

export default function useQueryTrueMoneyDeposits(
	payload?: GetTrueMoneyDepositsParams,
	options?: UnusedSkipTokenOptions<TrueMoneyDepositsResponse>,
) {
	return useQuery(queryTrueMoneyDepositsOptions(payload, options))
}
